import React from "react";

import { TextField } from "@mui/material";

import { BaseBadge, BaseLabel, colors } from "components";

import * as S from "./styles";

export interface TimeInputProps {
  id?: string;
  label: string;
  value?: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  setValue: (e: string | undefined) => void;
}

export const TimeInput: React.FC<TimeInputProps> = ({
  id,
  label,
  disabled,
  required,
  value,
  error,
  setValue,
}) => {
  return (
    <S.Container id={id} data-testid={id}>
      <S.ContainerHeader>
        <BaseLabel m="none" marginRight="8px" color={colors.neutral_gray_40}>
          {label}
        </BaseLabel>
        <S.LabelRequired>
          {required ? <BaseBadge color="warning" /> : <></>}
        </S.LabelRequired>
      </S.ContainerHeader>
      <TextField
        disabled={disabled}
        required={required}
        type="time"
        defaultValue={value}
        InputLabelProps={{
          shrink: true,
        }}
        fullWidth
        className="input_mui"
        error={error}
        onChange={(e) => setValue(e.target.value)}
      />
    </S.Container>
  );
};

export default TimeInput;
